import { render, staticRenderFns } from "./TaxesView.vue?vue&type=template&id=45377fe8&"
import script from "./TaxesView.vue?vue&type=script&lang=js&"
export * from "./TaxesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports